// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"26b9c60f","383":"caa095e6"}[chunkId] + ".chunk.css";
};